// Mandatory-3DS guard: we can only charge if we have a usable authentication result.
// Mirrors simply's usePayment.js onCardSubmit guard exactly (eci/cavv/dsTransId required,
// status 'N' (not authenticated) / 'R' (rejected) rejected).

export const assert3DS = (tds) => {
    if (!tds) return false;
    if (!tds.eci || !tds.authenticationValue || !tds.dsTransId) return false;
    if (tds.status === "N" || tds.status === "R") return false;
    return true;
};
